import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Route, Switch } from 'react-router-dom';
import ProfileInformation from 'components/client/profile'

const Account = ({ match }) => (
  <Switch>
    <Route
      path={match.path}
      component={ProfileInformation} />
  </Switch>
);

Account.propTypes = {
  match: PropTypes.object,
};

export default withRouter(Account);
